import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ng2-bootstrap/ng2-bootstrap';
import { TabsModule } from 'ng2-bootstrap/components/tabs';
import { SlimScrollModule } from 'ng2-slimscroll';

import { OnBoardingDashboardComponent } from './on-boarding-dashboard/on-boarding-dashboard.component';
import { OnBoardingRoutingModule } from './on-boarding-routing.module';
import { SharedModule } from './../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    OnBoardingRoutingModule,
    ModalModule,
    TabsModule,
    SharedModule,
    SlimScrollModule
  ],
  exports: [
    ModalModule,
    OnBoardingDashboardComponent
  ],
  declarations: [OnBoardingDashboardComponent]
})
export class OnBoardingModule { }



// WEBPACK FOOTER //
// ./src/app/on-boarding/on-boarding.module.ts